<template>
  <loading :loading="isLoading">
    <b-card header="Related extract data">
      <error :error="error"/>
      <div v-if="page">
        <b-list-group flush>
            <b-list-group-item>
              <shbe :shbe="page.ShbeForAddress"/>
            </b-list-group-item>
        </b-list-group>
      </div>
    </b-card>
  </loading>
</template>

<script>
import Loading from '../Loading.vue'
import Error from '../Error.vue'
import Shbe from '../extract_views/Shbe.vue'

export default {
  components: { Loading, Error, Shbe },
  props: ['reference'],
  data() {
    return {
      isLoading: true,
      page: null,
      error: null,
    };
  },
  mounted() {
    this.isLoading = true;
    const { access_token } = this.$store.state.oidcStore;
    this.$reportingApi.renderPage('panessex', access_token, {
      pageName: 'no_children_living_at_home',
      parameters: {
        reference: this.reference,
      },
    })
    .then((page) => { this.page = page; this.isLoading = false; })
    .catch((e) => { this.error = e.message; this.isLoading = false; });
  },
};
</script>
